var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"overlay__global-main",attrs:{"absolute":false,"value":_vm.isDataLoading}},[_c('v-flex',{staticClass:"text-center"},[_c('v-img',{staticClass:"mx-auto loader-img",attrs:{"src":"/img/loader.gif"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }